module.exports = __webpack_public_path__ + "img/meeyland.62ed09fb.svg";